import { getAuthAlias } from './auth';

// Only whether the last load returned a summary is saved, never the numbers, so an Amazonian's
// volunteering record is not left behind on a shared or borrowed computer.
const storageKey = (panel: string, alias: string) => `amzn-rv-hadActivitySummary-${panel}-${alias}`;

/** Whether the signed-in Amazonian's last load of this summary panel returned a summary. */
export function getHadActivitySummary(panel: string): boolean {
  const alias = getAuthAlias();
  return alias !== null && localStorage.getItem(storageKey(panel, alias)) === 'true';
}

/**
 * Never throws. It runs inside the summary query, so a browser that refuses the write (storage full,
 * or storage blocked) would otherwise turn a successful load into a failed one and hide the panel.
 * The saved value only decides whether a loader shows next time, so losing it costs nothing.
 */
export function saveHadActivitySummary(panel: string, hadSummary: boolean) {
  const alias = getAuthAlias();
  if (!alias) return;
  try {
    localStorage.setItem(storageKey(panel, alias), String(hadSummary));
  } catch {
    // Best effort: whatever was saved before stays as it was.
  }
}
